import { dom, escapeHtml, getFieldError } from './dom';

export interface UiI18n {
	orderReceived: string;
	tyMessagePending: string;
	tyMessageConfirmed: string;
	tyNotePending: string;
	tyNoteConfirmed: string;
	orderId: string;
	program: string;
	payment: string;
	status: string;
	total: string;
}

export function createUI(i18n: UiI18n, userEmail = '') {
	return {
		showError(message: string) {
			if (!dom.errorBanner || !dom.errorText) return;

			dom.errorText.textContent = message;
			dom.errorBanner.style.display = '';
			dom.errorBanner.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			});
		},

		hideError() {
			if (dom.errorBanner) {
				dom.errorBanner.style.display = 'none';
			}
		},

		showFieldError(field: string, message: string) {
			const el = getFieldError(field);
			if (el) {
				el.textContent = message;
				el.classList.add('active');
			} else {
			}

			const input = document.querySelector(`[name="${field}"]`);
			if (input) {
				input.classList.add('ac-input--error');
			}
		},

		clearFieldErrors() {
			document.querySelectorAll('.ac-field-error').forEach((el) => {
				el.textContent = '';
				el.classList.remove('active');
			});

			document.querySelectorAll('.ac-input--error').forEach((el) => {
				el.classList.remove('ac-input--error');
			});
		},

		setLoading(loading: boolean) {
			if (!dom.submitBtn) return;

			dom.submitBtn.disabled = loading;
			dom.submitBtn.classList.toggle('ac-btn--loading', loading);
		},

		showThankYou(order: Record<string, unknown>) {
			const checkoutView = document.getElementById('ac-view-checkout');
			const tyView = document.getElementById('ac-view-thankyou');

			if (!checkoutView || !tyView) return;

			const clientName = escapeHtml(String(order.client_name || ''));
			const programTitle = escapeHtml(String(order.program_title || ''));
			const isConfirmed =
				order.status === 'confirmed' || order.payment_status === 'paid';

			const msgEl = document.getElementById('ac-ty-message');
			if (msgEl) {
				const tyMessage = isConfirmed
					? i18n.tyMessageConfirmed
					: i18n.tyMessagePending;
				msgEl.innerHTML = tyMessage
					.replace('%1$s', `<strong>${clientName}</strong>`)
					.replace('%2$s', `<strong>${programTitle}</strong>`);
			}

			const detailsEl = document.getElementById('ac-ty-details');
			if (detailsEl && order) {
				const amount =
					order.currency && order.amount != null
						? `${escapeHtml(String(order.currency))} ${Number(order.amount).toFixed(2)}`
						: '';

				const statusLabel = escapeHtml(
					String(order.payment_status || order.status || '').replace(/_/g, ' '),
				);

				const rows: Array<[string, string, boolean]> = [];

				if (order.id) {
					rows.push([
						i18n.orderId,
						`#AC-${escapeHtml(String(order.id))}`,
						false,
					]);
				}
				if (order.program_title) {
					rows.push([i18n.program, programTitle, false]);
				}
				if (order.payment_method) {
					rows.push([
						i18n.payment,
						escapeHtml(
							String(order.payment_method_title || order.payment_method),
						),
						false,
					]);
				}
				if (statusLabel) {
					rows.push([i18n.status, statusLabel, true]);
				}
				if (amount) {
					rows.push([i18n.total, amount, false]);
				}

				detailsEl.innerHTML = rows
					.map(
						([label, value, highlight]) =>
							`<div class="ac-thankyou__row"><span>${label}</span><span${highlight ? ` class="ac-thankyou__highlight ac-thankyou__highlight--${value}"` : ''}>${value}</span></div>`,
					)
					.join('');
			}

			const noteEl = document.getElementById('ac-thankyou__note');
			if (noteEl) {
				const email = escapeHtml(String(order.client_email || userEmail || ''));
				if (email) {
					const tyNote = isConfirmed ? i18n.tyNoteConfirmed : i18n.tyNotePending;
					noteEl.innerHTML = tyNote.replace('%s', `<strong>${email}</strong>`);
				}
			}

			checkoutView.style.display = 'none';
			tyView.style.display = '';
			window.scrollTo({ top: 0, behavior: 'smooth' });
		},
	};
}
